/**
 * Auto-generated file containing all package dependencies and their exact installed versions.
 * This file is generated by the generate-dependencies script.
 * Do not edit manually — it will be overwritten on the next run.
 *
 * Versions are extracted from pnpm-lock.yaml to show exact installed versions,
 * not the version ranges from package.json.
 */

export const DEPENDENCIES = {
  '@dimforge/rapier3d-compat': '0.18.2',
  '@msgpack/msgpack': '3.1.3',
  '@recast-navigation/core': '0.43.1',
  '@recast-navigation/three': '0.43.1',
  '@tweenjs/tween.js': '25.0.0',
  'dat.gui': '0.7.9',
  'esbuild-wasm': '0.28.0',
  'fflate': '0.8.2',
  'jiti': '2.7.0',
  'manifold-3d': '3.5.1',
  'nanoid': '5.1.11',
  'nipplejs': '0.10.2',
  'postprocessing': '6.39.1',
  'recast-navigation': '0.43.1',
  'reflect-metadata': '0.2.2',
  'stats.js': '0.17.0',
  'three': 'npm:@gnsx/three@0.184.19',
  'three-mesh-bvh': '0.9.9',
  'ts-morph': '27.0.2',
  'tweakpane': '4.0.5',
  'xatlas-three': '0.2.1',
  'yaml': '2.9.0',
  'zod': '3.25.76',
  'zustand': '5.0.14',
  'ws': '8.20.0',
} as const;

export const DEV_DEPENDENCIES = {
  '@gltf-transform/core': '4.3.0',
  '@gltf-transform/extensions': '4.3.0',
  '@gltf-transform/functions': '4.3.0',
  '@gnsx/dev-tools': 'link:../dev-tools',
  '@rollup/plugin-node-resolve': '16.0.3',
  '@tweakpane/core': '2.0.5',
  '@types/dat.gui': '0.7.13',
  '@types/jsdom': '27.0.0',
  '@types/qunit': '2.19.14',
  '@types/three': 'npm:@gnsx/three-types@0.184.10',
  '@types/ws': '8.18.1',
  '@typescript-eslint/utils': '8.59.2',
  'commander': '14.0.3',
  'esbuild': '0.28.0',
  'jsdom': '27.4.0',
  'lint-staged': '16.4.0',
  'qunit': '2.25.0',
  'rollup-plugin-visualizer': '6.0.11',
  'sharp': '0.34.5',
  'typedoc': '0.28.19',
  'vite': '8.0.12',
  'vite-plugin-mkcert': '2.0.0',
  'vite-plugin-wasm': '3.6.0',
} as const;

export const CATALOG_DEPENDENCIES = {
  '@earendil-works/pi-agent-core': '0.79.3',
  '@earendil-works/pi-ai': '0.79.3',
  '@earendil-works/pi-coding-agent': '0.79.3',
  '@huggingface/transformers': '3.8.1',
  '@modelcontextprotocol/sdk': '1.29.0',
  '@stylistic/eslint-plugin': '5.10.0',
  '@types/cors': '2.8.19',
  '@types/express': '5.0.6',
  '@types/multer': '2.1.0',
  '@types/node': '25.9.1',
  '@types/react': '19.2.17',
  '@types/react-dom': '19.2.3',
  '@typescript-eslint/eslint-plugin': '8.59.2',
  '@typescript-eslint/parser': '8.59.2',
  'ai': '6.0.205',
  'concurrently': '9.2.1',
  'cors': '2.8.6',
  'dotenv': '17.4.2',
  'eslint': '9.39.4',
  'eslint-plugin-import': '2.32.0',
  'eslint-plugin-unused-imports': '4.4.1',
  'express': '5.2.1',
  'firebase-admin': '13.9.0',
  'multer': '2.1.1',
  'react': '19.2.7',
  'react-dom': '19.2.7',
  'tsup': '8.5.1',
  'tsx': '4.21.0',
  'turbo': '2.9.14',
  'typescript': '5.9.3',
} as const;

export const ALL_DEPENDENCIES = {
  ...DEPENDENCIES,
  ...DEV_DEPENDENCIES,
  ...CATALOG_DEPENDENCIES,
} as const;

export type DependencyName = keyof typeof ALL_DEPENDENCIES;
